import { createTheme } from '@material-ui/core';

export default createTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#F22F46',
    },
  },
  sidebarWidth: 260,
  width: 100,
});
